"use strict";

var SoaModel = require('./SoaModel');
var endpoints = require('dibs-endpoints');
var Newsletter = SoaModel.extend();

var root = typeof window === 'undefined' ? global : window;
var bunsen = root.bunsen = root.bunsen || {};

var _ = require('underscore');

module.exports = bunsen.Newsletter = Newsletter;

    _.extend(Newsletter.prototype, {
    url: function () {
        // TODO: find a better way to get the user ID
        return endpoints.userNewsletters(this.parents[0].id);
    }
});



//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/Newsletters.js
// module id = 1590
// module chunks = 62